<template>
    <div class="d-inline-block mb-18">
        <!-- * Iconed Action Sheet -->
        <div class="alert body-alertDriver" role="alert">
            
            <h4 class="alert-title">راننده گرامی</h4>
            <p class="m-2 mb-0 mt-0">
                از پرداخت هرگونه وجه به عنوان کمیسیون و ... به صاحب بار خودداری نمایید.
            </p>
            <p class="m-0" style="text-align: left">
                <a data-bs-toggle="offcanvas" @click="knowMore" data-bs-target="#actionMore" class="btn btn-more m-0">بیشتر
                    بدانید!
                </a>
            </p>
            <!-- Content Action Sheet -->
            <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" id="actionMore">
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title">هشدار</h5>
                    <button type="button" :id="'closeAlert_' + loadId" data-bs-dismiss="modal" style="display: none">
                        <ion-icon name="close-circle-outline" role="img" class="md hydrated"
                            aria-label="flash outline"></ion-icon>
                    </button>
                </div>
                <div class="offcanvas-body">
                    <div class="action-sheet-content">
                        <h4>در این موارد به شدت احتیاط کنید:</h4>
                        <ul class="dotted">
                            <li>ایران ترابر هیچ‌گونه مسئولیتی در قبال پرداخت‌های احتمالی شما به عنوان کمیسیون، رزرو بار،
                                شیرینی و ... به صاحبین بار نخواهد داشت.</li>
                            <li>آگهی کننده بار درخواست کمیسیون و.. دارد. (توجه نمایید که ایران ترابر اکیداٌ توصیه می‌کند
                                از پرداخت وجه بابت کمیسیون و... به آگهی کننده بار خودداری نمایید.)</li>
                            <li>آگهی کننده بار اطلاعات دقیقی از مکان بارگیری ارئه نمی‌دهد.</li>
                            <li>آگهی کننده بار درخواست حمل بار بدون صدور بارنامه را دارد.</li>
                            <li>قیمت کرایه بالا، غیرعادی و وسوسه کننده است.</li>
                        </ul>
                        <h4 class="text-center px-3 text-orange">توجه: در صورت مشاهده هرگونه آگهی مشکوک با تیم پشتیبانی
                            با ما تماس بگیرید.</h4>
                            <a href="#" class="btn btn-list text-danger d-none" :id="'knowMore_' + loadId" data-bs-dismiss="offcanvas">
                                <span>بستن</span>
                            </a>
                        <a :href="tel" class="btn background-TEAL btn-block text-light btn-block mb-1">
                            <ion-icon name="call-outline" role="img" class="md hydrated"
                                aria-label="logo dropbox"></ion-icon>
                            تماس با پشتیبانی
                        </a>
                        <a href="/terms-and-conditions" class="btn background-TEAL btn-block text-light btn-block">
                            <ion-icon name="help-buoy-outline" role="img" class="md hydrated"
                                aria-label="logo dropbox">
                            </ion-icon>
                            قوانین و مقررات
                        </a>
                    </div>
                </div>
            </div>
            <!-- * Content Action Sheet -->
        </div>
    </div>
</template>
<script>
export default {
    name: 'alertDriver',
    props: ['loadId'],
    data() {
        return {
            tel: 'tel:' + window.localStorage.getItem("tel"),
        };
    },
    methods:{
        knowMore() {
            localStorage.setItem("knowMore", this.loadId);
            if (history.pushState) {
                var newurl = window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname +
                    "?knowMore=1";
                window.history.pushState({ path: newurl }, "", newurl);
            }
        }
    }
}
</script>
<style scoped>
ul.dotted {
    list-style-type: square;
}

.mb-18{
    margin-bottom: 18px;
}

.btn-more {
    color: #ff5e00;
}

.body-alertDriver {
    border: 1px solid #ff5e005e;
    margin-bottom: 2rem;
}

.text-orange {
    color: #ff5e00;
}
</style>